import styled from 'styled-components';

export const PaginationContainer = styled.div`
    width: 100%;
    background: rgba(0, 0, 0, 0.01);
    display: flex;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
